module.exports = __webpack_public_path__ + "img/Anytime Fitness.1f24801a.svg";